<template>
  <v-dialog v-model="showFileRenameDialog" persistent width="35%" height="40%">
    <v-card>
      <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-size: 20px;color: black" class="alibabaPuHuiTiFontFamily">
        文件重命名
        <v-spacer></v-spacer>
        <p @click="hideDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;"
           class="iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text class="pa-0" >
        <div style="display: flex;height: 50px;line-height: 50px;margin-top: 40px;" class="px-12">
          <p style="color: black;font-size: 16px;">文件名</p>
          <v-text-field v-model="tempFileName"
                        dense outlined
                        hide-details style="width:60%;margin-left: 50px;color: black">
          </v-text-field>
        </div>
        <div style="display: flex;height: 20px;line-height: 20px;margin-left:143px;color: red;font-size: 14px">
          <p v-if="status !== ''" class="iconfontFamily">&#xe6a2;</p>
          <p v-if="status === 'same'">与原文件名一致</p>
          <p v-if="status === 'empty'">文件名不能为空</p>
          <p v-if="status === 'exist'">已存在同名文件</p>
          <p v-if="status === 'tooLong'">文件名称过长</p>
        </div>
        <div style="width: 100%;height: 150px;position:relative;">
          <div @click="renameConfirm" class="alibabaPuHuiTiFontFamily create-btn">
            新建
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FileRenameDialog',
  props: ['showFileRenameDialog', 'originalFileName', 'originalFileId'],
  data() {
    return {
      tempFileName: '',
      status: '',
      maxFileNameCharacter: 30,
    }
  },
  methods: {
    hideDialog() {
      this.$emit('closeRenameDialog')
    },
    renameConfirm() {
      if (this.tempFileName === this.originalFileName) {
        this.status = 'same'
        return
      } else if (this.tempFileName === '') {
        this.status = 'empty'
        return
      } else if (this.tempFileName.length > this.maxFileNameCharacter) {
        this.status = 'tooLong'
        return
      }
      let params = new FormData()
      params.append('fileId', this.originalFileId)
      params.append('fileName', this.tempFileName)
      this.$axios({
        method: 'post',
        url: '/authorApi/z-geo-file/rename',
        data: params
      }).then((resp) => {
        resp = resp['data']
        console.log(resp)
        if (resp['status'] === 200) {
          console.log('修改成功')
          this.status = ''
          this.$store.state.snackbarShow = true
          this.$store.state.snackbarText = "重命名完成"
          this.$store.state.snackbarType = 'success'
          this.$emit('closeRenameDialog')
          this.$emit('searchInputEnter')
        } else if (resp['status'] === 308) {
          this.status = 'exist'
        }
      })
    }
  },
  mounted() {
    console.log(this.originalFileId)
    this.tempFileName = this.originalFileName
  }
}
</script>

<style scoped>
.create-btn {
  width: 100px;
  height: 35px;
  background-color: rgba(30, 58, 138, 1);
  color: white;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
  position: absolute;
  right: 48px;
  bottom: 30px;
}
</style>
<style>
.v-input {
  font-size: 16px;
}
</style>